/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Delivered_Period_LabelInputs */

const vi_order_delivered_period_label = /** @type {(inputs: Order_Delivered_Period_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày giao`)
};

/**

* @param {Order_Delivered_Period_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_delivered_period_label = /** @type {((inputs?: Order_Delivered_Period_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Delivered_Period_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_delivered_period_label(inputs)
});